import { PaginatedPoi } from './../shared/models/paginated-poi.model';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { of } from 'rxjs';
import { Poi } from '../core/poi/poi.model';
import { PoiActionService } from '../core/poi/poi.action';

@Injectable()
export class PoiListResolver implements Resolve<Poi[]> {
  constructor(private service: ApiService,
              private poiAction: PoiActionService) {}

  resolve() {
    return this.service.getPoi(
      0,
      null,
      null,
      null,
      null,
      true
    ).pipe(
      first(),
      tap((paginatedPoi: PaginatedPoi) => {
        this.poiAction.paginatedPoiList(paginatedPoi);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di POI');
        return of(err);
      })
    );
  }
}
